/**
 * Since we don't use any accented text in typeaheads, this is a shim
 * for remove-accents to prevent it from bloating out the bundle size.
 * See https://github.com/kentcdodds/match-sorter/issues/70
 */
export default function removeAccentsShim(input) {
  return input;
}
